import styled from 'styled-components';
import {
  PaddingSize,
  isBackgroundLight,
  isBackgroundVeryLight,
} from '../common';

export const CpChatPageWidgetWrapper = styled.div.attrs<{
  className?: string;
  isDisabled?: boolean;
  background: string;
}>((props) => {
  const isLight = props.background ? isBackgroundLight(props.background) : true;
  const isVeryLight = props.background
    ? isBackgroundVeryLight(props.background)
    : true;

  if (isVeryLight) {
    return {
      className: 'cp-very-light-background',
    };
  }
  if (isLight) {
    return {
      className: 'cp-light-background',
    };
  }

  return {
    className: 'cp-dark-background',
  };
})<{
  paddingY?: PaddingSize;
  isDisabled?: boolean;
  background: string;
}>`
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
  height: 100%;
  max-height: 100%;
  overflow-y: hidden;
  padding-left: var(--spacing-06);
  padding-right: var(--spacing-06);
  padding-top: 0;
  padding-bottom: var(--spacing-06);
  background: ${(props) => props.background};

  &.cp-dark-background .cp-auto-adjust-color {
    --cp-text-primary: var(--cp-white);
    --cp-text-secondary: var(--cp-white);
    --cp-text-placeholder: var(--cp-white);
  }

  @media (max-width: 480px) {
    padding: 0;
  }

  /* padding left and right to var(--cp-spacing-05) in tab mode where min width is max width is 768px and min width is 481px */
  @media (min-width: 481px) and (max-width: 768px) {
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
    padding-bottom: var(--cp-spacing-05);
  }
`;
